import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import '../../css/calendar.css'
import Aos from 'aos'
import axios from 'axios'

const Calendar = () => {

    const [calendarList, setCalendarList] = useState([]);

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    const fetchCalendar = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/calendar`);
            if (response.data.status === "Success") {
                setCalendarList(response.data.reportDetail);
            }
            else {
                console.error("Unable to get data!", response.data.errorDetail);
            }
        }
        catch (error) {
            console.error("Error Fetching Data!", error);
        }
    }

    // Sort calendarData from bottom to top
    calendarList.sort((a, b) => {
        // Assuming year is a string, convert it to a number for comparison
        return Number(b.id) - Number(a.id);
    });

    const handleOpenPdf = (data) => {
        const pdfUrl = `${process.env.REACT_APP_IMG_URL}/calendars/${data}`;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = '_blank';
        link.click();
    }

    useEffect(() => {
        fetchCalendar();
    }, [])

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='calendar-body'>
                    <div className='calendar-header' data-aos='fade-right'>
                        <h3>क्यालेण्डर</h3>
                    </div>
                    <div className='bg-white rounded shadow table-body' data-aos='fade-right'>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>S.N.</th>
                                    <th>Title</th>
                                    <th>Year</th>
                                    <th>Detail</th>
                                </tr>
                            </thead>
                            <tbody>
                                {calendarList.length > 0 ? (
                                    calendarList.map((item, idx) => (
                                        <tr key={idx}>
                                            <td className='sn'>{idx + 1}</td>
                                            <td>{item.Title}</td>
                                            <td>{item.Year}</td>
                                            <td>
                                                <button
                                                    className='show-button'
                                                    onClick={() => handleOpenPdf(item.PdfUrl)}
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4}>No Record Found In Server!</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default Calendar